import { Check, X, AlertCircle } from 'lucide-react';

export function ScoreTracker({ correct, incorrect, typos, total, current }) {
    const percentage = total > 0 ? Math.round(((current) / total) * 100) : 0;

    return (
        <div 
            data-testid="score-tracker"
            className="sticky top-16 z-40 bg-background/95 backdrop-blur-sm border-b border-border py-4"
        >
            <div className="max-w-4xl mx-auto px-6">
                {/* Progress bar */}
                <div className="w-full h-1 bg-muted mb-4">
                    <div 
                        className="progress-beam"
                        style={{ width: `${percentage}%` }}
                        data-testid="progress-bar"
                    />
                </div>

                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-4">
                        <div className="score-badge score-correct" data-testid="score-correct">
                            <Check className="w-3 h-3" strokeWidth={2} />
                            <span>{correct}</span>
                        </div>
                        <div className="score-badge score-incorrect" data-testid="score-incorrect">
                            <X className="w-3 h-3" strokeWidth={2} />
                            <span>{incorrect}</span>
                        </div>
                        {typos !== undefined && (
                            <div className="score-badge score-typo" data-testid="score-typos">
                                <AlertCircle className="w-3 h-3" strokeWidth={2} />
                                <span>{typos}</span>
                            </div>
                        )}
                    </div>

                    <span className="font-mono text-xs tracking-wider text-muted-foreground">
                        {current} / {total}
                    </span>
                </div>
            </div>
        </div>
    );
}
